import React from "react";
import { lifeShackProductFacts } from "@src/config/productFacts";
import styles from "./DrivenByData.module.css";

const productPrinciples = [
  {
    title: "Clear preferences",
    body: "Define target roles, locations, and other search criteria before the application workflow starts.",
  },
  {
    title: "Candidate controls",
    body: "Pause activity, review submitted applications, and block companies that should not receive an application.",
  },
  {
    title: "Visible activity",
    body: "Use the dashboard to understand what was attempted, what completed, and where a workflow needs attention.",
  },
];

const DrivenByData = () => {
  const statistics = lifeShackProductFacts.approvedHomepageStatistics;
  const approvedStatistics = [
    {
      value: `${statistics.timeSavedPercent}%`,
      label: "time saved on repetitive application work",
    },
    {
      value: `${statistics.jobListings / 1000000}M+`,
      label: "job opportunities searched",
    },
    {
      value: `${statistics.companies.toLocaleString()}+`,
      label: "companies supported",
    },
  ];

  return (
    <section className={styles.section}>
    <h2 className={styles.title}>
      Set your preferences. Stay informed as applications go out.
    </h2>
    <p className={styles.intro}>
      Set preferences, block companies, pause Auto Apply, and review submitted
      activity. You cannot review or approve each application before it is sent.
      Results vary by candidate and job market.
    </p>
    <div
      aria-label="LifeShack usage statistics"
      className={styles.statsGrid}
    >
      {approvedStatistics.map((statistic) => (
        <div
          key={statistic.label}
          className={styles.statCard}
        >
          <strong className={styles.statValue}>
            {statistic.value}
          </strong>
          <span className={styles.statLabel}>
            {statistic.label}
          </span>
        </div>
      ))}
    </div>
    <div className={styles.principlesGrid}>
      {productPrinciples.map((principle) => (
        <article
          key={principle.title}
          className={styles.principleCard}
        >
          <h3 className={styles.principleTitle}>
            {principle.title}
          </h3>
          <p className={styles.principleBody}>
            {principle.body}
          </p>
        </article>
      ))}
    </div>
    </section>
  );
};

export default DrivenByData;
